import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { alertAction } from '../../Redux/Actions/alertAction';

const AlertMessage = () => {
    const dispatch = useDispatch();
    const { alert } = useSelector(state => state.alert);

    useEffect(() => {
        if (alert) {
            setTimeout(() => {
                dispatch(alertAction())
            }, 4000);
        }
        console.log(alert);
    }, [alert]);

    return (
        <div className="alert bg-green-600  py-3 px-6 mb-3 text-base text-white inline-flex items-center w-full alert-dismissible fade show" role="alert">
            <strong className="mr-1"> <i className="fa-solid fa-check mr-2 text-lg font-extrabold"></i>Successfully Updated  </strong>
            <button type="button" className="btn-close box-content w-1 h-1 p-1 ml-auto text-yellow-900 border-none rounded-none opacity-30 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-yellow-900 hover:opacity-75 hover:no-underline animation " data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
    )
}

export default AlertMessage;